import { useOutletContext } from "react-router";
import type { PortalWorkspaceContext } from "../components/PortalWorkspaceLayout";
import PortalDashboardPage from "./PortalDashboardPage";
import TenantTeamMemberHomePage from "./TenantTeamMemberHomePage";

/** Routes each authenticated portal actor to the home surface supported by their role. */
const PortalHomePage = () => {
  const { actorType } = useOutletContext<PortalWorkspaceContext>();
  return actorType === "agency_user" ? <PortalDashboardPage /> : <TenantTeamMemberHomePage />;
};

export default PortalHomePage;
